( function () {
	'use strict';

	window.define = function ( params, fn ) {
		fn( angular );
	};

	function cookies () {
		return function () {
			return '';
		};
	}

	function PD360Config () {
		return function () {
			return { 'nodeSessionServer' : '' };
		};
	}

	function loggedInUser ( Session ) {
		return Session.getCredentials();
	}

	angular.module( 'ngMarionetteCore', [] );

	angular.module( 'ngMarionetteCore' )
		.factory( 'PD360Config', PD360Config )
		.factory( 'loggedInUser', [ 'Session', loggedInUser ] )
		.factory( 'cookies', cookies );
} )( );
